import { defineMessage } from "react-intl";
// reference: https://gist.github.com/ndbroadbent/588fefab8e0f1b459fcec8181b41b39c
export const USER_LANGUAGE_CODES = {
  FRENCH: "fr",
  ENGLISH: "en-gb",
  SPANISH_MEXICO: "es-mx",
};

export const PATIENT_LANGUAGE_CODES = {
  ARABIC: "ar",
  FRENCH: "fr",
  SWAHILI: "sw",
  ENGLISH: "en-gb",
  KAMBA: "kam",
};

export const NIGERIAN_PATIENT_LANGUAGE_CODES = {
  FULANI: "fulani",
  HAUSA: "hausa",
  IGBO: "igbo",
  YORUBA: "yoruba",
  ZABARMAWA: "zabarmawa",
};

export const arabic = defineMessage({
  id: "language.arabic",
  defaultMessage: "Arabic",
});

export const english = defineMessage({
  id: "language.english",
  defaultMessage: "English",
});

export const OTHER_LANGUAGE_CODE = "other";

export const other = defineMessage({
  id: "language.other",
  defaultMessage: "Other",
});

export const french = defineMessage({
  id: "language.french",
  defaultMessage: "French",
});

export const kamba = defineMessage({
  id: "language.kamba",
  defaultMessage: "Kamba",
});

export const spanishMexico = defineMessage({
  id: "language.spanishMexico",
  defaultMessage: "Spanish",
});

export const swahili = defineMessage({
  id: "language.swahili",
  defaultMessage: "Swahili",
});

// local Ghanean languages

export const asante = defineMessage({
  id: "language.asante",
  defaultMessage: "Asante Twi",
});

export const akuapem = defineMessage({
  id: "language.akuapem",
  defaultMessage: "Akuapem Twi",
});

export const gaDangme = defineMessage({
  id: "language.gaDangme",
  defaultMessage: "Ga Dangme",
});

export const ewe = defineMessage({
  id: "language.ewe",
  defaultMessage: "Ewe",
});

export const dagbanli = defineMessage({
  id: "language.dagbanli",
  defaultMessage: "Dagbanli",
});

export const hausa = defineMessage({
  id: "language.hausa",
  defaultMessage: "Hausa",
});

export const gonja = defineMessage({
  id: "language.gonja",
  defaultMessage: "Gonja",
});

export const kasem = defineMessage({
  id: "language.kasem",
  defaultMessage: "Kasem",
});

export const nzema = defineMessage({
  id: "language.nzema",
  defaultMessage: "Nzema",
});

export const fanteTwi = defineMessage({
  id: "language.fanteTwi",
  defaultMessage: "Fante Twi",
});

export const dagaare = defineMessage({
  id: "language.dagaare",
  defaultMessage: "Dagaare",
});

export const frafra = defineMessage({
  id: "language.frafra",
  defaultMessage: "Frafra",
});
export const kusase = defineMessage({
  id: "language.kusase",
  defaultMessage: "Kusase",
});
export const waale = defineMessage({
  id: "language.waale",
  defaultMessage: "Waale",
});
export const dagomba = defineMessage({
  id: "language.dagomba",
  defaultMessage: "Dagomba",
});
export const mumprusi = defineMessage({
  id: "language.mumprusi",
  defaultMessage: "Mumprusi",
});
export const konkomba = defineMessage({
  id: "language.konkomba",
  defaultMessage: "Konkomba",
});
export const fulaniG = defineMessage({
  id: "language.ghana.fulani",
  defaultMessage: "Fulani",
});
export const sisala = defineMessage({
  id: "language.sisala",
  defaultMessage: "Sisala",
});
export const bimoba = defineMessage({
  id: "language.bimoba",
  defaultMessage: "Bimoba",
});
export const mossi = defineMessage({
  id: "language.mossi",
  defaultMessage: "Mossi",
});
export const chokosi = defineMessage({
  id: "language.chokosi",
  defaultMessage: "Chokosi",
});
export const zabrama = defineMessage({
  id: "language.zabrama",
  defaultMessage: "Zabrama",
});

// local nigeria languages
export const fulani = defineMessage({
  id: "language.fulani",
  defaultMessage: "Fulani",
});

export const igbo = defineMessage({
  id: "language.igbo",
  defaultMessage: "Igbo",
});

export const yoruba = defineMessage({
  id: "language.yoruba",
  defaultMessage: "Yoruba",
});

export const zabarmawa = defineMessage({
  id: "language.zabarmawa",
  defaultMessage: "Zabarmawa",
});
